import SectionLabel from "./SectionLabel";
import { Reveal } from "./Reveal";

const PILLARS = [
    {
        numeral: "I",
        title: "Production",
        copy: "Feature development and physical production for stories that cross borders — supported by three decades of infrastructure and relationships.",
    },
    {
        numeral: "II",
        title: "Post-Production",
        copy: "Picture, sound and finishing held to international standards, delivered with the discipline of a working producer's eye.",
    },
    {
        numeral: "III",
        title: "Distribution",
        copy: "Positioning films for audiences worldwide, with an emphasis on international co-productions.",
    },
];

export default function Pillars() {
    return (
        <section
            id="craft"
            data-testid="craft-section"
            className="scroll-mt-20 border-t border-cream/5 px-6 py-28 sm:py-36"
        >
            <div className="mx-auto max-w-6xl">
                <SectionLabel id="craft">What We Do</SectionLabel>
                <div className="mt-14 grid gap-10 md:grid-cols-3">
                    {PILLARS.map((p, i) => (
                        <Reveal
                            key={p.numeral}
                            delay={i * 0.12}
                            data-testid={`pillar-card-${i + 1}`}
                        >
                            <div className="group h-full border-t border-cream/15 pt-8 transition-colors duration-500 hover:border-gold/50">
                                <p className="font-label text-sm tracking-[0.4em] text-gold">
                                    {p.numeral}
                                </p>
                                <h3 className="mt-5 font-display text-2xl font-light text-cream transition-colors duration-500 group-hover:text-gold sm:text-3xl">
                                    {p.title}
                                </h3>
                                <p className="mt-4 text-[15px] leading-relaxed text-cream/70">
                                    {p.copy}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
